/*
 *
 * ── Why this exists as its own file ──────────────────────────────────────────────────────────
 * `safeHref` in lib/utils.js is the server's guard, and it cannot be reached from the browser.
 * Until now no client surface needed one, because every client-rendered href was either a constant
 * or a value the server had already checked. The admin console broke that: it renders the page URL
 * a feedback report was filed from, which is whatever the reporter's browser was pointing at.
 *
 * The wrong answer was to write a second copy inside the console. An href is a sink no matter how
 * the element was built — `javascript:` in an anchor runs on click even when the anchor came from
 * createElement — and a guard that exists in two places is the shape that eventually diverges by
 * one scheme and reintroduces the bug. So it is one dependency-free module, loaded by whoever
 * needs it, and this file is the client's single source of truth.
 *
 * ── The rule, matching lib/utils.js exactly ──────────────────────────────────────────────────
 *   http:// or https://      pass
 *   /path or #fragment       pass (same origin by construction)
 *   anything:with-a-scheme   '#' — that includes javascript:, data:, vbscript:, file:
 *   schemeless               pass; the browser reads it as a relative path
 *
 * Keep the two in step. If one gains a rule the other must gain it too; they guard the same sink
 * on two sides of the same request.
 */
'use strict';
(function () {
  if (window.PortalSafeUrl) return;

  function href(url) {
    var u = String(url === null || url === undefined ? '' : url).trim();
    if (/^https?:\/\//i.test(u)) return u;
    if (u.charAt(0) === '/' || u.charAt(0) === '#') return u;
    // Has a scheme, and it isn't http(s). Refused rather than rendered, so a click cannot execute
    // it and a reader is not handed a link that quietly does something else.
    if (/^[a-z][a-z0-9+.-]*:/i.test(u)) return '#';
    return u;
  }

  window.PortalSafeUrl = { href: href };
})();
